"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SlackChannels = void 0;
var SlackChannels;
(function (SlackChannels) {
    SlackChannels["FiatReplenishmentIssues"] = "FIAT_REPLENISHMENT_ISSUES";
})(SlackChannels = exports.SlackChannels || (exports.SlackChannels = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiU2xhY2tDaGFubmVscy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uL3NyYy9TbGFja0NoYW5uZWxzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUFBLElBQVksYUFFWDtBQUZELFdBQVksYUFBYTtJQUN2QixzRUFBcUQsQ0FBQTtBQUN2RCxDQUFDLEVBRlcsYUFBYSxHQUFiLHFCQUFhLEtBQWIscUJBQWEsUUFFeEIifQ==